<template>
  <div class="content">
    <div class="export-loading" v-if="loading">
      <LoadingAnim />
    </div>
    <PageHeader :breadcrumbLinks="breadcrumbLinks" :title="'SMS'"
      :subtitle="'Deny List ' + $t('generic-str.and') + ' OPT-Outs'" />
    <section class="page-content container-fluid">
      <div class="cards-wrapper">
        <CardComponent ref="card" variant="tertiary">
          <template #header>
            <div class="card-header">
              <div class="card-title header_title">
                <span class="material-symbols-outlined">person_off</span>
                <span>Deny List</span>
              </div>
              <form @submit.prevent="search" class="form-group col px-0 mb-0">
                <div class="input-group">
                  <input placeholder="" type="text" class="form-control" v-model="searchQuery" ref="searchInput" />
                  <div class="input-group-prepend">
                    <button @click="search" type="button" class="btn icon_btn m-0">
                      <span class="material-symbols-outlined"> search </span>
                    </button>
                  </div>
                </div>
              </form>
              <div class="opts_card flex items-center gap-2 mt-2 mt-md-0">
                <!-- Criar novo -->
                <button class="btn" @click="showDenylist">
                  <span class="material-icons add_person"> add </span>
                </button>
                <!-- Exportar -->
                <button-element type="" @click="download" :disabled="blacklists.length == 0">
                  <span class="material-icons-outlined title">download</span>
                </button-element>
                <!-- Excluir -->
                <button class="btn" :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
                  @click="deleteAll" v-bind:disabled="selectedBlacklists.length == 0 || isSending">
                  <span class="material-symbols-outlined title"> delete_forever </span>
                </button>
              </div>
            </div>
          </template>
          <div v-if="!blacklists.length && fetched" class="card-body">
            <LottieAnimNoData />
            <h5 class="card-title text-center">
              {{ $t("sms.deny-list.none") }}
            </h5>
            <!-- Nenhum deny list cadastrado -->
            <p class="text-center">{{ $t("sms.deny-list.lbl-create") }}</p>
            <!-- Cadastre seu primeiro deny list. -->
          </div>
          <div class="card-body" v-if="fetched">
            <div class="table-responsive" v-if="blacklists.length">
              <table class="table table-infos">
                <thead>
                  <tr>
                    <!-- <th scope="col">
                        {{ $tc('app.name', 1) }}
                      </th> -->
                    <th class="checkbox-wrapper" scope="col">
                      <div class="control-group opt-2">
                        <label class="control control-checkbox" for="customCheckTAll"><input id="customCheckTAll"
                            v-model="selectAllBlacklists" type="checkbox" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                      {{ $tc("generic-str.lbl-number", 1) }}
                    </th>
                    <th scope="col">
                      {{ $t("generic-str.expire") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(blacklist, i) in blacklists" :key="blacklist.id">
                    <!-- <td>
                        <span class="img-wrapper">
                          <div class="image">R</div>
                          <span>Rodrigo Silva</span>
                        </span>
                      </td> -->
                    <td data-label="Número: ">
                      <span class="checkbox-wrapper">
                        <div class="control-group opt-2">
                          <label class="control control-checkbox" :for="'blacklist-check' + i">
                            <input v-model="selectedBlacklists" :id="'blacklist-check' + i" :value="blacklist"
                              type="checkbox" />
                            <div class="control_indicator"></div>
                          </label>
                        </div>
                        <span>+{{ blacklist.mobile_number }}</span>
                      </span>
                    </td>
                    <td v-if="blacklist.expired_at" data-label="Expira em: ">
                      <span>
                        <span>{{ blacklist.expired_at }}</span>
                      </span>
                    </td>
                    <td v-else data-label="Expira em: ">
                      {{ $t("generic-str.never") }}
                      <!-- Nunca -->
                    </td>
                    <td>
                      <dropdown>
                        <template v-slot:text>
                          <span class="material-symbols-outlined title"> more_horiz </span>
                        </template>
                        <template #items>
                          <!-- Editar -->
                          <button @click="showDenylistEdit(blacklist.id)" class="dropdown-item">
                            {{ $t("generic-str.edit") }}
                          </button>
                          <!-- Remover -->
                          <button class="dropdown-item" @click="destroy(blacklist.id)">
                            {{ $t("generic-str.remove") }}
                          </button>
                        </template>
                      </dropdown>
                      <!-- <div class="dropdown">
                          <a
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                            ><span class="material-symbols-outlined title">
                              more_horiz
                            </span></a
                          >
                          <div class="dropdown-menu" style="">
                            <a class="dropdown-item"> Edit </a
                            ><button class="dropdown-item">Remove</button>
                          </div>
                        </div> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div v-else class="qt-block-ui relative" style="padding: 120px" /> -->
          <div class="loading min-h-300" v-else>
            <LoadingAnim />
          </div>
          <div class="card-footer">
            <div class="container-fluid">
              <div class="row">
                <pagination :lastPage="pages" @change="fetch" />
              </div>
            </div>
          </div>
        </CardComponent>
        <opted-card />
        <KeywordsCard ref="keywords" />
      </div>
    </section>
    <!-- Sidebar - denylist -->
    <SidebarComponent ref="denylist" :title="$t('generic-str.status.lbl-new')" @submit="fetch()" backdrop>
      <form @submit.prevent="save">
        <div class="modal-body">
          <div class="form-body">
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{
                $tc("generic-str.lbl-number", 2)
                }}</label>
              <div class="col-md-12">
                <textarea v-model="form.numbers" type="text" class="form-control"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{
                $t("generic-str.expire")
                }}</label>
              <div class="col-md-12">
                <date-picker v-model="form.expired_at" :config="options" class="form-control input-date"
                  :placeholder="$t('generic-str.date-hour')"></date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending" type="submit"
            class="btn btn-yup-purple">
            {{ $t("generic-str.save") }}
          </button>
          <button type="button" class="btn btn-yup-purple-outline" @click="hide">
            {{ $t("generic-str.cancel") }}
          </button>
        </div>
      </form>
    </SidebarComponent>
    <SidebarComponent ref="denylistEdit" :title="$t('generic-str.edit')" @submit="fetch()" backdrop>
      <form @submit.prevent="saveEdit">
        <div class="modal-body">
          <div class="form-body">
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{
                $tc("generic-str.lbl-number", 2)
                }}</label>
              <div class="col-md-12">
                <textarea v-model="data.mobile_number" type="text" class="form-control"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="control-label text-left col-md-12 text-left-m">{{
                $t("generic-str.expire")
                }}</label>
              <div class="col-md-12">
                <date-picker v-model="data.expired_at" :config="options" class="form-control input-date"
                  :placeholder="$t('generic-str.date-hour')"></date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hideEdit">
            {{ $t("generic-str.cancel") }}
          </button>
          <button :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }" :disabled="isSending" type="submit"
            class="btn btn-primary">
            {{ $t("generic-str.save") }}
          </button>
        </div>
      </form>
    </SidebarComponent>
    <create-optouts-modal id="create-optouts-modal" @submit="fetchAll(1)" />
    <optouts-modal id="optouts-modal" @submit="fetchAll(1)" />
    <create-key-modal id="create-key-modal" @submit="fetchKeywords" />
    <key-modal id="key-modal" @submit="fetchKeywords" />
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/rebranding/PageHeader.vue';
import SmsService from '@/services/sms.service';
import Swal from 'sweetalert2';
import $ from 'jquery';
import Pagination from '@/components/rebranding/Pagination.vue';
import ButtonElement from '@/components/rebranding/elements/ButtonElement.vue';
import Dropdown from '@/components/Dropdown.vue';
import LottieAnimNoData from '@/components/rebranding/animLottie/NoData.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';
// Blacklist
import CreateBlacklistModal from '@/components/rebranding/sms/CreateBlacklistModal.vue';
import BlacklistModal from '@/components/sms/BlacklistModal.vue';
import BlacklistService from '@/services/blacklist.service';
// Optout
import OptedCard from '@/components/rebranding/sms/optouts/OptedCard.vue';
import CreateKeyModal from '@/components/rebranding/sms/CreateKeyModal.vue';
import KeyModal from '@/components/sms/KeyModal.vue';
import CreateOptoutsModal from '@/components/sms/CreateOptoutsModal.vue';
import OptoutsModal from '@/components/sms/OptoutsModal.vue';
import CardComponent from '@/components/CardComponent.vue';
import KeywordsCard from '@/components/rebranding/sms/optouts/KeywordsCard.vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import SidebarComponent from '@/components/SidebarComponent.vue';
import moment from 'moment';

export default {
  name: 'SmsDenylist',
  components: {
    PageHeader,
    Pagination,
    ButtonElement,
    Dropdown,
    LottieAnimNoData,
    LoadingAnim,
    OptedCard,
    /* KeywordsCard, */
    CreateKeyModal,
    KeyModal,
    CreateOptoutsModal,
    OptoutsModal,
    CardComponent,
    KeywordsCard,
    datePicker,
    SidebarComponent,
  },
  data() {
    return {
      breadcrumbLinks: {
        1: '/sms/reports/stat',
        2: '/sms/denylist',
      },

      fetched: false,
      isSending: false,
      searchQuery: null,
      blacklists: [],
      form: {
        page: 1,
        channel: 'sms',
      },
      pages: 1,
      templates: [],
      selectedBlacklists: [],
      selectedTemplates: [],
      options: {
        format: 'DD/MM/YYYY HH:mm',
        useCurrent: false,
        keepInvalid: true,
      },
      data: {
        id: null,
        mobile_number: '',
        expired_at: null,
      },
    };
  },
  computed: {
    selectAllBlacklists: {
      get() {
        if (this.blacklists) {
          return this.selectedBlacklists.length === this.blacklists.length;
        }
        return false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.blacklists.forEach((client) => {
            selected.push(client);
          });
        }

        this.selectedBlacklists = selected;
      },
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    search() {
      this.fetched = false;
      this.form.numbers = this.searchQuery;
      this.form.page = 1;

      SmsService.getBlacklists(this.form).then(
        (response) => {
          this.fetched = true;
          this.blacklists = response.data;
          this.pages = response.last_page;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    fetch(page = 1) {
      this.form.page = page;
      this.fetched = false;
      SmsService.getBlacklists(this.form).then(
        (response) => {
          this.fetched = true;
          this.blacklists = response.data;
          this.pages = response.last_page;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    selectedBlacklistsChange(param) {
      this.selectedBlacklists = param.selectedBlacklists;
    },
    destroy(id) {
      Swal.fire({
        title: this.$t('generic-str.r-sure'),
        text: 'O número será removido da deny list',
        icon: 'warning',
        showCancelButton: true,
        /* confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33', */
        confirmButtonText: this.$t('warnings.btn-y-delete'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.fetched = false;
          SmsService.destroyBlacklist(id).then(
            () => {
              this.fetch();
              Swal.fire('Removido!', 'O número foi removido da deny list.', 'success');
            },
            (error) => {
              this.content = error;
            },
          );
        }
      });
    },
    deleteAll() {
      Swal.fire({
        title: this.$t('warnings.blacklist.remove-deny'),
        text: this.$t('warnings.blacklist.text-deny'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          const toDelete = [];
          this.selectedBlacklists.forEach((item) => {
            toDelete.push(item.id);
          });
          this.isSending = true;
          SmsService.deleteBlacklists({ ids: toDelete }).then(
            () => {
              this.fetch();
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('warnings.blacklist.removed-deny'),
                type: 'success',
              });
              this.$root.$emit('updated.blacklist');
              this.isSending = false;
              this.selectedBlacklists = [];
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
                content: error.response.data.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        }
      });
    },
    download() {
      const link = document.createElement('a');

      if (link.download === undefined) {
        this.$toast.show({
          title: this.$t('sms.infos.filters.status.lbl-error'),
          content: 'Sem suporte para download',
          type: 'danger',
        });

        return;
      }

      this.loading = true;

      BlacklistService.export({ channel: 'sms' })
        .then(
          (data) => {
            const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) {
              // IE 10+
              navigator.msSaveBlob(blob, 'denylist.csv');
            } else {
              // feature detection
              // Browsers that support HTML5 download attribute
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', 'denylist.csv');
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          },
          (error) => {
            this.content = error;
            this.$toast.show({
              title: this.$t('sms.infos.filters.status.lbl-error'),
              content: error.response.data.message,
              type: 'danger',
            });
          },
        )
        .finally(() => {
          this.loading = false;
        });
    },
    /* Optouts */
    fetchKeywords() {
      this.$refs.keywords.fetch(1);
    },
    selectedTemplatesChange(param) {
      this.selectedTemplates = param.selectedTemplates;
    },
    deleteAllOpt() {
      Swal.fire({
        title: this.$t('warnings.optouts.remove-number'),
        text: this.$t('warnings.optouts.text-number'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('generic-str.yes'),
      }).then((result) => {
        if (result.value) {
          const toDelete = [];
          this.selectedTemplates.forEach((item) => {
            toDelete.push(item.id);
          });
          this.isSending = true;
          SmsService.deleteAllOptouts({ ids: toDelete }).then(
            () => {
              this.$toast.show({
                title: this.$t('generic-str.success'),
                content: this.$t('warnings.optouts.removed-number'),
                type: 'success',
              });
              this.$root.$emit('updated.optout');
              this.isSending = false;
              this.selectedTemplates = [];
            },
            (error) => {
              this.$toast.show({
                title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
                content: error.response.data.message,
                type: 'danger',
              });
              this.isSending = false;
            },
          );
        }
      });
    },
    save() {
      this.isSending = true;
      if (this.form.expired_at) {
        const expiredAt = moment(this.form.expired_at, 'DD/MM/YYYY HH:mm').format(
          'YYYY-MM-DD HH:mm',
        );
        this.form.expired_at = expiredAt;

        console.log(this.form.expired_at);
        console.log(this.form);
      }
      SmsService.createBlackList({
        expired_at: this.form.expired_at,
        numbers: this.form.numbers,
        channel: 'sms',
      }).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: 'Deny list criada com sucesso',
            type: 'success',
          });
          this.$emit('submit');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
          console.log(error.response.data.message);
        },
      );
    },
    saveEdit() {
      this.isSending = true;

      // Formata a data se existir
      let expiredAt = null;
      if (this.data.expired_at) {
        expiredAt = moment(this.data.expired_at, 'DD/MM/YYYY HH:mm').format(
          'YYYY-MM-DD HH:mm',
        );
      }

      SmsService.editBlackList({
        id: this.data.id,
        mobile_number: this.data.mobile_number,
        expired_at: expiredAt,
        channel: 'sms',
      }).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('key-word-component.update'),
            type: 'success',
          });
          this.$emit('submit');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
          console.log(error.response.data.message);
        },
      );
    },
    showDenylist() {
      this.$refs.denylist.toggle();
    },
    showDenylistEdit(id) {
      // Encontra o item na lista pelo ID
      const itemToEdit = this.blacklists.find((item) => item.id === id);

      if (itemToEdit) {
        // Preenche os dados no objeto data
        this.data.id = itemToEdit.id;
        this.data.mobile_number = itemToEdit.mobile_number;
        this.data.expired_at = itemToEdit.expired_at;

        // Abre o sidebar de edição
        this.$refs.denylistEdit.toggle();
      }
    },
    hide() {
      this.$refs.denylist.toggle();

      this.form = {
        numbers: '',
        expired_at: '',
      };
    },
    hideEdit() {
      this.$refs.denylistEdit.toggle();
      this.data = {
        id: null,
        mobile_number: '',
        expired_at: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  position: relative;
}

.export-loading {
  position: absolute;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.btn i {
  line-height: 1;
  color: inherit;
}

/* Rebranding */
.eye_icon {
  color: #bfc5cb;
}

.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }

  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }

  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }

  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .icon_btn {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid var(--form-border);
    border-left-color: transparent;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    span {
      color: var(--gray-font-color);
    }
  }
}

.darkmode .rebranding .form-control,
.rebranding .form-control {
  border-right: unset !important;
}

.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
  border-left-color: transparent;
}

.header_options .input-group>input,
.header_options .input-group button {
  height: 50px;
}

.rebranding .add_person {
  cursor: pointer;
}

.rebranding .opts_card button {
  height: fit-content;
  padding: 0;
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.img-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.img-wrapper>.image {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #570069;
  width: 50px;
  height: 50px;
  padding: 24px;
  border-radius: 50%;
  color: #fff;
  font-weight: 400;
}

.table-infos td {
  vertical-align: unset;
}

.rebranding .card {
  height: calc(100% - 1.875rem);
}

.rebranding .purple-add {
  background-color: var(--clr-yup-purple);
  color: #fff !important;
  transition: 0.5s;
}

.rebranding .purple-add:hover {
  background-color: var(--clr-yup-purple-hover);
}

.list-options li {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.list-options li .control-group {
  display: flex;
  gap: 10px;
  clear: both;
  width: 100%;
}

.list-options li .control-group .control {
  width: 100%;
}

.list-options li .control-group .control_indicator {
  float: left;
  margin-right: 10px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.table.table-infos th,
.table.table-infos thead th {
  border-bottom: unset;
}

.card-header .card-title {
  color: #697077 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
}

.header_title {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Static pagination */
.pagination {
  margin: 2px 0;
  white-space: nowrap;
  justify-content: flex-end;
}

/* @media (min-width: 1440px) {
  .denylist-col.col-lg-8 {
    -ms-flex: 0 0 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
} */
@media (min-width: 992px) and (max-width: 1440px) {
  .denylist-col.col-xl-8 {
    -ms-flex: 0 0 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.denylist-col .card-body {
  min-height: 300px;
}

.denylist-col .table-responsive {
  height: 100%;
  overflow-x: visible !important;
}

.form-wrapper {
  flex: 1 0 20%;
}

.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  border-bottom: none !important;
  padding-bottom: 0;
  border-bottom: none !important;
  padding-bottom: 0;
}

.opts_card {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

@media (min-width: 1660px) {
  .form-wrapper {
    min-width: 0;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    flex-basis: 0;
    flex-grow: 1;
  }
}

@media (max-width: 767.98px) {
  ::v-deep .actions.top-right {
    top: 22px !important;
  }

  .rebranding .card .card-header .header_title,
  .rebranding .header_title {
    width: 100%;
  }

  .actions {
    width: 43%;
  }

  .form-wrapper {
    flex: 1 0 40%;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .opts_card {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .cards-wrapper {
    display: flex;
    flex-direction: column;
  }
  .card-body {
    padding: 0 !important;
  }
}
</style>
